export { HookSystemModule } from './src/app/hook-system.module';
export { HookSystemService } from './src/app/services/hook-system.service';



// WEBPACK FOOTER //
// ./libs/hook-system/index.ts